import { ContactStatus, IContact } from 'clickNgo/entities/contact'
import { fetchContactsByPartnerId } from 'clickNgo/entities/contact/api'
import { fetchPartnerRequestById } from 'clickNgo/entities/partner/api'

interface ILoadPartnerData {
  contact: IContact
  relinkingNewPartnerId: string
}

export const loadPartnerData = async ({ contact, relinkingNewPartnerId }: ILoadPartnerData) => {
  const contacts = await fetchContactsByPartnerId(contact.partnerId)
  const availableContacts = contacts.filter(
    (c) => c.contactId !== contact.contactId && c.status !== ContactStatus.Inactive
  )

  const targetPartnerContacts = await fetchContactsByPartnerId(relinkingNewPartnerId)
  const targetPartner = await fetchPartnerRequestById(relinkingNewPartnerId, {
    cacheKey: relinkingNewPartnerId,
  })

  if (!targetPartner) throw new Error('Cant fetch target partner')

  return { availableContacts, targetPartnerContacts, targetPartner }
}
